import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function JungleNavigationCoFound() {
  const dateTexts = ['1911年', '4月', '8日'];
  const title = 'ジャングルナビゲーションカンパニー設立';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/skipper-canteen-walt-disney-world-restaurant-003.jpg'
  const description = (
    <>
      {'S.E.A.会員の'}
      <a href='/albert-falls'>
        {'アルバートフォールズ博士'}
      </a>
      {'が、探検家・冒険家の仲間たちを手助けする目的でジャングルナビゲーションカンパニーを設立する。'}
      {'会社のオフィス内には、S.E.A.の会員たちが利用するための秘密の部屋が隠されている。'}
    </>
  );
  const quoteDomain = 'disneytouristblog.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default JungleNavigationCoFound;
